import { useCallback, useEffect, useState } from 'react'

import { Input } from 'twyne-new.ui'

import { MAX_INTERVAL_QUANTITY, normalizeIntervalQuantity } from '../utils/chartIntervals'

export default function IntervalQuantityInput({ value, onChange }) {
  const [draft, setDraft] = useState(() => String(value))

  useEffect(() => {
    setDraft(String(value))
  }, [value])

  const handleChange = useCallback(event => {
    const raw = event.target.value
    setDraft(raw)

    if (raw === '') return

    onChange(normalizeIntervalQuantity(raw))
  }, [onChange])

  const handleBlur = useCallback(() => {
    setDraft(String(value))
  }, [value])

  return (
    <Input
      type="number"
      min={1}
      max={MAX_INTERVAL_QUANTITY}
      className="w-16 shrink-0 text-center"
      aria-label="Buckets per point"
      value={draft}
      onFocus={event => event.target.select()}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  )
}
